<div class="landing-container">
  <!-- Modern Hero Section with Category Cards -->
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">AI Analytics Platform</h1>
      <p class="hero-subtitle">Comprehensive AI-powered brand analysis across multiple industries and categories</p>
      <div class="hero-stats">
        <div class="stat-item">
          <span class="stat-number">2</span>
          <span class="stat-label">Industries</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">8</span>
          <span class="stat-label">Categories</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">3</span>
          <span class="stat-label">AI Models</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Category Grid Section -->
  <section class="categories-section">
    <div class="section-header">
      <h2>Explore Industries</h2>
      <p>Select an industry to analyze brands and get comprehensive AI insights</p>
    </div>

    <div class="category-grid">
      <!-- Automotive -->
      <!-- <div class="category-card" (click)="selectIndustry('automotive')">
        <div class="card-icon">
          <mat-icon>directions_car</mat-icon>
        </div>
        <h3>Automotive</h3>
        <p>Electric cars, SUVs, sedans, luxury & sports vehicles</p>
        <div class="card-stats">
          <span>5 categories</span>
          <span>•</span>
          <span>30+ brands</span>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div> -->

      <!-- Technology -->
      <!-- <div class="category-card" (click)="selectIndustry('technology')">
        <div class="card-icon">
          <mat-icon>devices</mat-icon>
        </div>
        <h3>Technology</h3>
        <p>Smartphones, laptops, tablets & wearables</p>
        <div class="card-stats">
          <span>4 categories</span>
          <span>•</span>
          <span>25+ brands</span>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div> -->

      <!-- Fashion -->
      <!-- <div class="category-card" (click)="selectIndustry('fashion')">
        <div class="card-icon">
          <mat-icon>style</mat-icon>
        </div>
        <h3>Fashion</h3>
        <p>Luxury, streetwear, accessories & footwear</p>
        <div class="card-stats">
          <span>4 categories</span>
          <span>•</span>
          <span>20+ brands</span>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div> -->

      <!-- Food & Beverage -->
      <!-- <div class="category-card" (click)="selectIndustry('food')">
        <div class="card-icon">
          <mat-icon>restaurant</mat-icon>
        </div>
        <h3>Food & Beverage</h3>
        <p>Fast food, beverages, fine dining & snacks</p>
        <div class="card-stats">
          <span>4 categories</span>
          <span>•</span>
          <span>25+ brands</span>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div> -->

      <!-- Healthcare -->
      <!-- <div class="category-card" (click)="selectIndustry('healthcare')">
        <div class="card-icon">
          <mat-icon>local_hospital</mat-icon>
        </div>
        <h3>Healthcare</h3>
        <p>Pharmaceuticals, medical devices & wellness</p>
        <div class="card-stats">
          <span>3 categories</span>
          <span>•</span>
          <span>15+ brands</span>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div> -->
    </div>
  </section>

  <!-- Features Section -->
  <section class="features-section">
    <div class="section-header">
      <h2>What You Get</h2>
      <p>Comprehensive AI analysis across multiple dimensions</p>
    </div>

    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>analytics</mat-icon>
        </div>
        <h4>AI Brand Index</h4>
        <p>Measure how well your brand is positioned across AI platforms</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>psychology</mat-icon>
        </div>
        <h4>Sentiment Analysis</h4>
        <p>Understand emotional tone and perception of your brand</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>trending_up</mat-icon>
        </div>
        <h4>Consumer Preferences</h4>
        <p>Discover what consumers value most in your category</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>share</mat-icon>
        </div>
        <h4>Content Distribution</h4>
        <p>Analyze how your content performs across platforms</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>science</mat-icon>
        </div>
        <h4>Methodology & Research</h4>
        <p>Advanced research methodologies with AI model validation</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <mat-icon>timeline</mat-icon>
        </div>
        <h4>Progress Tracking & Analytics</h4>
        <p>Monitor brand performance over time with trend analysis</p>
      </div>
    </div>
  </section>

  <!-- Original Platform Section -->
  <section class="platform-section">
    <div class="section-header">
      <h2>AI-Powered Analytics Platform</h2>
      <p>Comprehensive tools for brand analysis, university research, and educational insights powered by artificial
        intelligence.</p>
    </div>
  </section>

  <div class="features-grid">
    <mat-card *ngFor="let feature of features" class="feature-card" [style.border-left-color]="feature.color">
      <mat-card-header>
        <mat-card-title>
          <mat-icon [style.color]="feature.color">{{feature.icon}}</mat-icon>
          {{feature.title}}
        </mat-card-title>
        <mat-card-subtitle>{{feature.description}}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div class="feature-list">
          <ul>
            <li *ngFor="let item of feature.features">{{item}}</li>
          </ul>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button mat-raised-button [routerLink]="feature.route" [style.background-color]="feature.color" color="primary">
          <mat-icon>arrow_forward</mat-icon>
          Explore {{feature.title}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <mat-divider></mat-divider>

  <div class="info-section">
    <h2>About Our Platform</h2>
    <p>
      Our AI-powered platform provides comprehensive analytics and insights across multiple domains.
      From brand analysis to educational research, we leverage advanced artificial intelligence to deliver
      actionable insights and data-driven recommendations.
    </p>

    <div class="stats-grid">
      <div class="stat-item">
        <h3>4</h3>
        <p>Core Features</p>
      </div>
      <div class="stat-item">
        <h3>AI-Powered</h3>
        <p>Advanced Analytics</p>
      </div>
      <div class="stat-item">
        <h3>Real-time</h3>
        <p>Data Processing</p>
      </div>
      <div class="stat-item">
        <h3>Comprehensive</h3>
        <p>Insights & Reports</p>
      </div>
    </div>
  </div>
</div>